/**
 * DevExtreme (esm/__internal/ui/form/m_form.item_options_actions.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    data
} from "../../../core/element_data";
import {
    extend
} from "../../../core/utils/extend";
import ItemOptionAction from "./m_form.item_option_action";
import {
    getFullOptionName
} from "./m_form.utils";
class WidgetOptionItemOptionAction extends ItemOptionAction {
    tryExecute() {
        var {
            value: value
        } = this._options;
        var instance = this.findInstance();
        if (instance) {
            instance.option(value);
            return true
        }
        return false
    }
}
class TabOptionItemOptionAction extends ItemOptionAction {
    tryExecute() {
        var tabPanel = this.findInstance();
        if (tabPanel) {
            var {
                optionName: optionName,
                item: item,
                value: value
            } = this._options;
            var itemIndex = this._itemsRunTimeInfo.findItemIndexByItem(item);
            if (itemIndex >= 0) {
                tabPanel.option(getFullOptionName("items[".concat(itemIndex, "]"), optionName), value);
                return true
            }
        }
        return false
    }
}
class SimpleItemTemplateChangedAction extends ItemOptionAction {
    tryExecute() {
        return false
    }
}
class GroupItemTemplateChangedAction extends ItemOptionAction {
    tryExecute() {
        var preparedItem = this.findPreparedItem();
        if (null != preparedItem && preparedItem._prepareGroupItemTemplate && preparedItem._renderGroupContentTemplate) {
            preparedItem._prepareGroupItemTemplate(this._options.item.template);
            preparedItem._renderGroupContentTemplate();
            return true
        }
        return false
    }
}
class TabsOptionItemOptionAction extends ItemOptionAction {
    tryExecute() {
        var tabPanel = this.findInstance();
        if (tabPanel) {
            var {
                value: value
            } = this._options;
            tabPanel.option("dataSource", value);
            return true
        }
        return false
    }
}
class ValidationRulesItemOptionAction extends ItemOptionAction {
    tryExecute() {
        var {
            item: item
        } = this._options;
        var instance = this.findInstance();
        var validator = instance && data(instance.$element()[0], "dxValidator");
        if (validator && item) {
            var filterRequired = item => "required" === item.type;
            var oldContainsRequired = (validator.option("validationRules") || []).some(filterRequired);
            var newContainsRequired = (item.validationRules || []).some(filterRequired);
            if (!oldContainsRequired && !newContainsRequired || oldContainsRequired && newContainsRequired) {
                validator.option("validationRules", item.validationRules);
                return true
            }
        }
        return false
    }
}
class CssClassItemOptionAction extends ItemOptionAction {
    tryExecute() {
        var $itemContainer = this.findItemContainer();
        var {
            previousValue: previousValue,
            value: value
        } = this._options;
        if ($itemContainer) {
            $itemContainer.removeClass(previousValue).addClass(value);
            return true
        }
        return false
    }
}
var tryCreateItemOptionAction = (optionName, itemActionOptions) => {
    var _a, _b, _c;
    switch (optionName) {
        case "editorOptions":
        case "buttonOptions":
            return new WidgetOptionItemOptionAction(itemActionOptions);
        case "validationRules":
            return new ValidationRulesItemOptionAction(itemActionOptions);
        case "cssClass":
            return new CssClassItemOptionAction(itemActionOptions);
        case "badge":
        case "disabled":
        case "icon":
        case "tabTemplate":
        case "title":
            return new TabOptionItemOptionAction(extend(itemActionOptions, {
                optionName: optionName
            }));
        case "tabs":
            return new TabsOptionItemOptionAction(itemActionOptions);
        case "template":
            var itemType = null !== (_b = null === (_a = null === itemActionOptions || void 0 === itemActionOptions ? void 0 : itemActionOptions.item) || void 0 === _a ? void 0 : _a.itemType) && void 0 !== _b ? _b : null === (_c = itemActionOptions.itemsRunTimeInfo.findPreparedItemByItem(null === itemActionOptions || void 0 === itemActionOptions ? void 0 : itemActionOptions.item)) || void 0 === _c ? void 0 : _c.itemType;
            if ("simple" === itemType) {
                return new SimpleItemTemplateChangedAction(itemActionOptions)
            }
            if ("group" === itemType) {
                return new GroupItemTemplateChangedAction(itemActionOptions)
            }
            return new TabOptionItemOptionAction(extend(itemActionOptions, {
                optionName: optionName
            }));
        default:
            return null
    }
};
export default tryCreateItemOptionAction;
